export default "__VITE_ASSET__DsuGzNSG__"